import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { UserWithMetadataDtoRoleEnum } from '@kortxio/hub-api';
import { adminCampaignPrivileges } from 'features/admin-campaigns/helper';
import RequirePrivilege from 'features/user/components/RequirePrivilege';
import RequireRole from 'features/user/components/RequireRole';
import RouterDrawerListItem from 'layout/components/drawer/RouterDrawerListItem';
import { useKampusRoutes } from 'routes/hooks';

export function AdminDrawerListOptions() {
  const {
    routeAdminUserManagement,
    routeAdminCampaigns,
    routeAdminPersonaManagement,
    routeAdminPromptManagement,
    routeAdminAiResponses,
    routeAdminMonitoring,
  } = useKampusRoutes();

  return (
    <>
      <RequireRole requiredRoles={[UserWithMetadataDtoRoleEnum.KortxAdmin]}>
        <RouterDrawerListItem
          to={routeAdminUserManagement}
          text="User Administration"
          icon={<AdminPanelSettingsOutlinedIcon />}
        />
      </RequireRole>
      <RouterDrawerListItem
        to={routeAdminPersonaManagement}
        text="Personas"
        icon={<Diversity3OutlinedIcon />}
      />
      <RequirePrivilege requiredPrivileges={adminCampaignPrivileges}>
        <RouterDrawerListItem
          to={routeAdminCampaigns}
          text="Campaigns"
          icon={<CampaignOutlinedIcon />}
        />
      </RequirePrivilege>
      <RequirePrivilege
        requiredPrivileges={['PROMPT_CONFIGS_READ', 'PROMPT_CONFIGS_WRITE']}
      >
        <RouterDrawerListItem
          to={routeAdminPromptManagement}
          text="AI Prompt Configuration Management"
          icon={<SmartToyIcon />}
        />
      </RequirePrivilege>
      <RequirePrivilege requiredPrivileges={['AI_RESPONSES_READ']}>
        <RouterDrawerListItem
          to={routeAdminAiResponses}
          text="AI Response History"
          icon={<FactCheckIcon />}
        />
      </RequirePrivilege>
      <RequirePrivilege requiredPrivileges={['MONITORS_READ']}>
        <RouterDrawerListItem
          to={routeAdminMonitoring}
          text="Monitoring"
          icon={<MonitorHeartOutlinedIcon />}
        />
      </RequirePrivilege>
    </>
  );
}
